<template lang="pug">
#app
  v-app
    header-component
    v-content
      v-container
        router-view
    footer-component
  </div>
</template>

<script>
import HeaderComponent from '@/components/common/Header'
import FooterComponent from '@/components/common/Footer'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue